import React, { useState, useEffect, useCallback } from 'react';
// import RenderFormView from './RenderFormView';
import ActiveForm from './partials/ActiveForm'
import ValidatedForm from './partials/ValidatedForm';
import UnfilledForm from './partials/UnfilledForm';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import logger from '../lib/logger';
import integromat from '../lib/integromat';

import * as Yup from 'yup';
import { phoneRemovePlus, phoneTransform, yupCity, yupEmail, yupName, yupPhone } from '../lib/yupShared';

const SellcarForm = props => {
    // const { formValues, view, setStep, handleFormUpdates } = props;
    const { formValues, view, setStep, evaluateNewCar, handleFormUpdates } = props;

    const content = {
        heading: 'Sälj bilen till oss om du vill',
        desc: 'Gå vidare för att få ett dagsaktuellt prisförslag per telefon.'
    }
    const cityOptions = {
        'Bollnäs': 'Bollnäs',
        'Gävle': 'Gävle',
        'Hudiksvall': 'Hudiksvall',
        'Ljusdal': 'Ljusdal',
        'Luleå': 'Luleå',
        'Norrtälje': 'Norrtälje',
        'Sandviken': 'Sandviken',
        'Söderhamn': 'Söderhamn',
        'Sundsvall': 'Sundsvall',
        'Timrå': 'Timrå',
        'Uppsala': 'Uppsala',
        'Östhammar':'Östhammar',
        'Stockholm': 'Stockholm (Partner)',
        'Göteborg': 'Göteborg (Partner)',
        'Malmö': 'Malmö (Partner)',        
        'Västerås': 'Västerås (Partner)',
        'Örebro': 'Örebro (Partner)',
        'Linköping': 'Linköping (Partner)',
        'Helsingborg': 'Helsingborg (Partner)',
        'Jönköping': 'Jönköping (Partner)',
        'Norrköping': 'Norrköping (Partner)',
        'Umeå': 'Umeå (Partner)',
        'Södertälje': 'Södertälje (Partner)',
        'Borås': 'Borås (Partner)',
        'Halmstad': 'Halmstad (Partner)',
        'Eskilstuna': 'Eskilstuna (Partner)',
        'Karlstad': 'Karlstad (Partner)',
    };
    const [sendStatus, setSendStatus] = useState(false);

    const [sellView, setSellView] = useState(view);

    useEffect(() => {
        setSellView(view);
    }, [view])



    const sendForm = useCallback(() => {
        // if(sellView === 'sending' && sendStatus === true) {
        setSendStatus(false);

        integromat.sell({
            registrationNumber: formValues.regnr,
            mileage: formValues.mileage,
            condition: formValues.condition,
            sellingPrice: formValues.price_filtered ? formValues.price_filtered : 0,
            waykeValue: formValues.price_prediction ? formValues.price_prediction : 0,
            'sellingPrice-fancy': formValues.price_filtered ? formValues.price_filtered?.toLocaleString() + ' kr' : 'Kan ej värderas',
            'waykeValue-fancy': formValues.price_prediction ? formValues.price_prediction?.toLocaleString() + ' kr' : 'Kan ej värderas',
            email: formValues.email,
            name: formValues.name,
            make: formValues.make,
            model: formValues.model,
            modelYear: formValues.modelYear,
            color: formValues.color,
            phone: phoneRemovePlus(formValues.phone),
            comment: formValues.comment,
            anlaggning: formValues.city,
        })

        window?.dataLayer?.push({
            event: 'valuationConversion'
        });

        setSellView('sending');
        const timer = setTimeout(() => {
            setStep(5);
        }, 2000);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValues, sendStatus, sellView, setStep]);


    useEffect(() => {
        if (sendStatus === true) {
            logger('sendstatus true, sendform...');
            sendForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sendStatus]);


    function handleUpdate(values) {
        handleFormUpdates(values);
        setSendStatus(true);
        // setSubmitting(false);
    }


    switch (sellView) {
        case 'active':


            const form = (
                <>
                    <Formik
                        // initialValues={{email: formValues.email, date: formValues.date, time: formValues.time, city: formValues.city, name: formValues.name, phone: formValues.phone, comment: formValues.comment } }
                        initialValues={{ email: formValues.email, city: formValues.city, name: formValues.name, phone: formValues.phone, comment: formValues.comment }}
                        validationSchema={Yup.object({
                            email: yupEmail,
                            name: yupName,
                            city: yupCity,
                            phone: yupPhone,
                        })}
                        onSubmit={(values, actions) => {
                            // console.log(values);                           
                            setTimeout(() => {
                                values.phone = phoneTransform(values.phone)
                                handleUpdate(values);
                                // setSendStatus(true);
                                actions.setSubmitting(false);
                            }, 100);

                        }}
                    >
                        {({ values, setFieldValue, isSubmitting }) => (


                            <Form>
                                <div className="form-fields estimate">
                                    <div className="input-field">
                                        <label htmlFor="city">Välj den ort som är närmast dig</label>
                                        <Field name="city" as="select">
                                            <option value='' key='none'>Välj ort</option>
                                            {Object.entries(cityOptions).map(([key, value]) => {
                                                return <option value={key} key={key}>{value}</option>
                                            })}
                                        </Field>
                                        <div className="form-error-msg">
                                            <ErrorMessage name="city" />
                                        </div>
                                    </div>

                                    <div className="input-field">
                                        <label htmlFor="name">Namn</label>
                                        <Field name="name" type="text" />
                                        <div className="form-error-msg">
                                            <ErrorMessage name="name" />
                                        </div>
                                    </div>
                                    <div className="input-field">
                                        <label htmlFor="email">Din e-post</label>
                                        <Field name="email" type="email" />
                                        <div className="form-error-msg">
                                            <ErrorMessage name="email" />
                                        </div>
                                    </div>
                                    <div className="input-field">
                                        <label htmlFor="phone">Telefonnummer</label>
                                        <Field name="phone" type="phone" />
                                        <div className="form-error-msg">
                                            <ErrorMessage name="phone" />
                                        </div>
                                    </div>
                                    <div className="input-field">
                                        <label htmlFor="comment">Kommentar</label>
                                        <div className="text-desc">Här kan du berätta mer om bilen, exempelvis om den har extrautrustning.</div>
                                        <Field name="comment" type="textarea" as="textarea" />
                                        <div className="form-error-msg">
                                            <ErrorMessage name="comment" />
                                        </div>
                                    </div>

                                </div>

                                <div className="form-button-container">
                                    <button className="form-button-wide" type="submit" disabled={isSubmitting}>Skicka</button>
                                </div>
                                <div className="field-link">
                                    <button className="form-button-link" onClick={evaluateNewCar}>
                                        Värdera en annan bil
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </>
            )
            return (<ActiveForm content={content} form={form} step={4} />)
        case 'unfilled': return <UnfilledForm content={content} step={4} />
        case 'validated': return <ValidatedForm content={content} step={4} values={[formValues.email]} setStep={setStep} />
        case 'loading': return <ViewLoading content={content} />
        case 'confirm': return <ViewConfirm content={content} />
        case 'sending': return <ViewSending content={content} />
        default: return <div>Default</div>
    }
}

export default SellcarForm

const ViewLoading = ({ content }) => {
    return (
        <div className="active-form">
            <div className="text-step">Steg 4 av 4</div>
            <div className="text-title">{content.heading}</div>
            <div className="field-is-loading">
                <div className="loader"></div>
                <p>Skickar förfrågan...</p>
            </div>
        </div>
    )
}

const ViewConfirm = ({ content }) => {
    return (
        <div className="active-form">
            <div className="text-step">Steg 4 av 4</div>
            <div className="text-title">{content.heading}</div>
            <div className="field-confirm">
                <p><b>Då var det skickat!</b> Vi hör av oss till dig inom kort för att bekräfta din bokning.</p>
            </div>
        </div>
    )
}

const ViewSending = ({ content }) => {
    return (
        <div className="active-form">
            <div className="text-step">Steg 4 av 4</div>
            <div className="text-title">{content.heading}</div>
            <div className="field-is-loading">
                <div className="loader"></div>
                <p>Skickar uppgifter...</p>
            </div>
        </div>
    )
}
